<template>
  <div class="bg-card-grey mt-3 mb-3">
    <div class="cardy-body-noBorder">
      <div class="row">
        <div class="col-xs-12 col-lg-12 mt-1 mb-2">
          <button
            style="width: 100%"
            class="color-white btn-add-items-tb bg-purple"
            @click="handleUpdate"
          >
            SALVAR
          </button>
        </div>
        <div class="col-xs-12 col-lg-12 mt-1 mb-2">
          <select class="form-control full" v-model="status">
            <option
              v-for="status in this.avaiableStatus"
              :key="status.value"
              :value="status.value"
            >
              {{ status.text }}
            </option>
          </select>
        </div>
        <div class="col-xs-12 col-lg-12 mt-1 mb-2">
          <button
            style="width: 100%"
            class="color-white btn-add-items-tb bg-light-purple"
            @click="openResume()"
          >
            <i class="far fa-file-alt f25 color-white" style="float: left"></i>
            CURRÍCULO
          </button>
        </div>
        <div class="col-xs-12 col-lg-12 mt-1 mb-1">
          <button
            style="width: 100%"
            class="color-white btn-add-items-tb bg-light-purple"
            @click="openVideo()"
          >
            <i class="fas fa-video color-white f25" style="float: left"></i>
            VIDEOS DO CANDIDATO(A)
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Resume from "../Candidates/Resume.vue";
import Videos from "../Videos/Index.vue";
export default {
  props: ["candidate", "candidate_id"],
  data: () => ({
    status: "",
    avaiableStatus: [
      { text: "Desativado", value: 0 },
      { text: "Ativado", value: 1 },
    ],
  }),
  mounted() {
    this.status = this.candidate.status;
  },
  methods: {
    handleUpdate() {
      let candidates = {
        status: this.status,
      };

      axios
        .put(`/recruiters/talent_banks/${this.candidate.id}/candidate/edit`, {
          candidates,
        })
        .then((response) => {
          if (response.data.updated) {
            this.$toast.success("Candidato atualizado com sucesso!");
            eventBus.$emit("updateInfo");
            return;
          }
          this.$toast.error("Candidato não pode ser atualizado");
        });
    },
    openResume() {
      this.$modal.show(
        Resume,
        {
          resume: this.candidate.curriculum_text,
          id: this.candidate.id,
        },
        {
          width: "40%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    openVideo() {
      this.$modal.show(
        Videos,
        {
          candidate_id: this.candidate.id,
        },
        {
          width: "70%",
          height: "auto",
          scrollable: true,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
</style>